import React from "react";
import {ErrorBoundary} from "react-error-boundary";
import {Alert, Button} from "antd";
import {ReloadOutlined} from "@ant-design/icons";
import {ENV} from "../configs/AppConfig";


export default function LayoutError(props) {

    return (
        <ErrorBoundary fallbackRender={fallbackRender}>
            {props.children}
        </ErrorBoundary>
    )
}

function fallbackRender({error, resetErrorBoundary}) {

    return (
        <div style={{height: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Alert
                style={{minWidth: "50%"}}
                showIcon
                message="Une erreur est survenue"
                description={ENV==="PROD"?null:<div dangerouslySetInnerHTML={{__html: error?.stack?.replaceAll("\n", "<br/>")}}/>}
                type="error"
                action={
                    <Button
                        size="small"
                        type="ghost"
                        onClick={resetErrorBoundary}
                        icon={<ReloadOutlined/>}>
                        Recharger la page
                    </Button>
                }
            />

        </div>
    );
}
